import { rest } from 'msw';
import { formatApiPath } from '@/api/utils';
import { DEFAULT_MOCK_SERVICES_SMF_RESPONSE, SERVICES_SMF_PATH } from './smf.constants';
var smfUrl = formatApiPath(SERVICES_SMF_PATH);
/**
 * Mock handler for test server
 */
export var mockGetServicesSmfHandler = rest.get(smfUrl, function (req, res, ctx) { return res(ctx.status(200), ctx.json(DEFAULT_MOCK_SERVICES_SMF_RESPONSE)); });
